/* tslint:disable */
/* eslint-disable */
/**
 * compass-pro
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SetRequireJoinApprovalRequest
 */
export interface SetRequireJoinApprovalRequest {
    /**
     * 
     * @type {boolean}
     * @memberof SetRequireJoinApprovalRequest
     */
    require_join_approval: boolean;
}

/**
 * Check if a given object implements the SetRequireJoinApprovalRequest interface.
 */
export function instanceOfSetRequireJoinApprovalRequest(value: object): value is SetRequireJoinApprovalRequest {
    if (!('require_join_approval' in value) || value['require_join_approval'] === undefined) return false;
    return true;
}

export function SetRequireJoinApprovalRequestFromJSON(json: any): SetRequireJoinApprovalRequest {
    return SetRequireJoinApprovalRequestFromJSONTyped(json, false);
}

export function SetRequireJoinApprovalRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): SetRequireJoinApprovalRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'require_join_approval': json['require_join_approval'],
    };
}

export function SetRequireJoinApprovalRequestToJSON(json: any): SetRequireJoinApprovalRequest {
    return SetRequireJoinApprovalRequestToJSONTyped(json, false);
}

export function SetRequireJoinApprovalRequestToJSONTyped(value?: SetRequireJoinApprovalRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'require_join_approval': value['require_join_approval'],
    };
}

